import type { MarginType } from './materials'

export type DiagramPoint = { x: number; y: number }

export type MaterialDiagram = {
  prepPath: string
  crownPath: string
  leftMargin: DiagramPoint
  rightMargin: DiagramPoint
}

function createDiagram(
  prepPath: string,
  leftMarginX: number,
  rightMarginX: number,
): MaterialDiagram {
  const baselineY = 158
  return {
    prepPath,
    crownPath: `M${leftMarginX} ${baselineY} C70 126 70 82 74 54 Q180 32 286 54 C290 82 290 126 ${rightMarginX} ${baselineY}`,
    leftMargin: { x: leftMarginX, y: baselineY },
    rightMargin: { x: rightMarginX, y: baselineY },
  }
}

/** Paired 2D sections whose crown and preparation share both margin endpoints. */
export const MATERIAL_DIAGRAMS: Record<MarginType, MaterialDiagram> = {
  chamfer: createDiagram(
    'M80 158 Q86 158 86 148 L86 70 Q180 54 274 70 L274 148 Q274 158 280 158',
    80,
    280,
  ),
  shoulder: createDiagram(
    'M76 158 L96 158 L96 70 Q180 54 264 70 L264 158 L284 158',
    76,
    284,
  ),
  'deep-chamfer': createDiagram(
    'M76 158 Q98 158 98 136 L98 72 Q180 56 262 72 L262 136 Q262 158 284 158',
    76,
    284,
  ),
}
